export default "__VITE_ASSET__787921ee__"